var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMode(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.726 7.848H8.274C4.81 7.848 2 10.604 2 14.003v21.833c0 3.4 2.81 6.156 6.274 6.156h31.452c3.465 0 6.274-2.756 6.274-6.156V14.003c0-3.4-2.81-6.155-6.274-6.155z",
    fill: "#2E3133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12.155V33.98c0 1.633-.66 3.2-1.837 4.355a6.345 6.345 0 01-4.437 1.809H8.274a6.345 6.345 0 01-4.437-1.809A6.105 6.105 0 012 33.98V12.155c0-1.632.661-3.198 1.838-4.352A6.336 6.336 0 018.274 6h31.452a6.323 6.323 0 013.117.827 6.171 6.171 0 012.277 2.246c.57.931.874 1.996.88 3.082z",
    fill: "#454A4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.91 8.521H8.09c-2.095 0-3.793 1.666-3.793 3.721v8.961c0 2.056 1.698 3.721 3.793 3.721h31.82c2.095 0 3.793-1.665 3.793-3.72v-8.962c0-2.055-1.698-3.72-3.793-3.72z",
    fill: "#B3F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.568 33.746l5.113 3.721a1.783 1.783 0 002.465-.492c.17-.258.267-.556.28-.863V28.67a1.703 1.703 0 00-.28-.863 1.75 1.75 0 00-.687-.605 1.79 1.79 0 00-1.778.113l-5.113 3.72a1.734 1.734 0 00-.493.603 1.7 1.7 0 00.493 2.108z",
    fill: "#3BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.433 33.746l-5.113 3.721a1.783 1.783 0 01-2.466-.492 1.704 1.704 0 01-.28-.863V28.67c.014-.307.11-.605.28-.863.17-.258.408-.467.688-.605a1.789 1.789 0 011.778.113l5.113 3.72c.208.162.377.368.493.603a1.701 1.701 0 01-.493 2.108z",
    fill: "#F33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.518 32.392c0-2.99-2.47-5.414-5.518-5.414-3.047 0-5.518 2.424-5.518 5.413 0 2.99 2.47 5.413 5.518 5.413 3.047 0 5.518-2.423 5.518-5.413z",
    fill: "#8A9599"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.503 32.391c0-1.898-1.568-3.436-3.503-3.436-1.934 0-3.502 1.538-3.502 3.436s1.568 3.436 3.502 3.436c1.935 0 3.503-1.538 3.503-3.436z",
    fill: "#C2C9CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.93 8.521L23.444 24.924H12.19L26.674 8.521H37.93z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 6)",
    d: "M0 0h44v36H0z"
  })))));
}
export default SvgMode;